export default __webpack_public_path__ + "static/media/marc.e8607287.jpg";